import React from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

import { CollectionRouteParams } from '@/pages/learning/LearningCollection/LearningCollectionPage';
import { RouterLinkButton } from '@/components/Button/RouterLinkButton';
import { ButtonList } from '@/components/Button/ButtonList';
import { ROUTE_PATH } from '@/constants/routePaths';

export const BackToCollectionButton = (): JSX.Element | null => {
  const { t } = useTranslation('learning');
  const params = useParams<CollectionRouteParams>();

  return params?.collectionId ? (
    <ButtonList>
      <RouterLinkButton
        to={`${ROUTE_PATH.COLLECTION_BASE}/${params.collectionId}/${params.collectionName}`}
        $type="text"
        $iconPosition="left"
        $icon="long-arrow-alt-left"
      >
        {t('Back to collection')}
      </RouterLinkButton>
    </ButtonList>
  ) : null;
};
